import { clamp, lerp } from './math'

export interface EnergyPalette {
  deep: string
  core: string
  highlight: string
  glow: string
  text: string
}

type Rgb = [number, number, number]

const positive: EnergyPalette = {
  deep: '#541f27',
  core: '#c94f4d',
  highlight: '#f29a70',
  glow: '#e0645c',
  text: '#fff5f2',
}

const negative: EnergyPalette = {
  deep: '#123e37',
  core: '#238967',
  highlight: '#69c4a3',
  glow: '#31a67c',
  text: '#effcf7',
}

const neutral: EnergyPalette = {
  deep: '#283039',
  core: '#65707b',
  highlight: '#b5bdc5',
  glow: '#7e8b98',
  text: '#f3f6f8',
}

function parseHex(value: string): Rgb {
  const packed = Number.parseInt(value.slice(1), 16)
  return [(packed >> 16) & 255, (packed >> 8) & 255, packed & 255]
}

function blend(a: string, b: string, amount: number): string {
  const from = parseHex(a)
  const to = parseHex(b)
  const t = clamp(amount, 0, 1)
  const red = Math.round(lerp(from[0], to[0], t))
  const green = Math.round(lerp(from[1], to[1], t))
  const blue = Math.round(lerp(from[2], to[2], t))
  return `rgb(${red}, ${green}, ${blue})`
}

export function paletteForPolarity(polarity: number): EnergyPalette {
  const target = polarity >= 0 ? positive : negative
  const amount = Math.abs(clamp(polarity, -1, 1))
  // Stable bubbles use the exact endpoint palettes. Only bubbles currently
  // crossing the zero axis need a blended allocation.
  if (amount >= 1) return target
  return {
    deep: blend(neutral.deep, target.deep, amount),
    core: blend(neutral.core, target.core, amount),
    highlight: blend(neutral.highlight, target.highlight, amount),
    glow: blend(neutral.glow, target.glow, amount),
    text: blend(neutral.text, target.text, amount),
  }
}
